"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrap = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var DomUtil_1 = require("./DomUtil");
function handleFocus(e) {
    e.stopPropagation(); // just for TFS 739813 and 740525, c.f. PortalEventTrap
}
function handleBlur(e, onTrap) {
    var relatedTarget = DomUtil_1.findBlurRelatedTarget(e);
    if (relatedTarget && !e.currentTarget.contains(relatedTarget)) {
        e.target.focus();
        e.stopPropagation();
        if (onTrap) {
            onTrap(e);
        }
    }
}
exports.FocusTrap = function (props) {
    var onTrap = props.onTrap, divProps = tslib_1.__rest(props, ["onTrap"]);
    var handleBlurCallback = React.useCallback(function (e) {
        handleBlur(e, onTrap);
    }, [onTrap]);
    return React.createElement("div", tslib_1.__assign({}, divProps, { onBlur: handleBlurCallback, onFocus: handleFocus }));
};
//# sourceMappingURL=FocusTrap.js.map